import { FC } from 'react'

export type ExportToastStatus = 'progress' | 'success' | 'error'

export interface ExportToastBodyProps {
  status: ExportToastStatus
  /** Detail shown for the error state (e.g. the backend message). */
  message?: string
}

const TITLES: Record<ExportToastStatus, string> = {
  progress: 'Export In-Progress',
  success: 'Export complete',
  error: 'Export failed',
}

const SUBTITLES: Record<ExportToastStatus, string> = {
  progress:
    'Preparing your CSV — your download will begin automatically. Keep this tab open.',
  success: 'CSV downloaded.',
  error: 'Something went wrong while exporting.',
}

/** Two-line toast body (icon + title + subtitle) used for the Export CSV lifecycle. */
export const ExportToastBody: FC<ExportToastBodyProps> = ({
  status,
  message,
}: ExportToastBodyProps) => {
  const subtitle: string =
    status === 'error' ? message || SUBTITLES.error : SUBTITLES[status]

  return (
    <div className='export-toast'>
      <span className={`export-toast__icon export-toast__icon--${status}`}>
        {status === 'progress' && <ClockIcon />}
        {status === 'success' && <CheckIcon />}
        {status === 'error' && <AlertIcon />}
      </span>
      <span className='export-toast__text'>
        <span className='export-toast__title'>{TITLES[status]}</span>
        <span className='export-toast__subtitle'>{subtitle}</span>
      </span>
    </div>
  )
}

const ClockIcon: FC = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'>
    <circle cx='12' cy='12' r='9' />
    <polyline points='12 7 12 12 15 14' />
  </svg>
)

const CheckIcon: FC = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'>
    <path d='M20 6 9 17l-5-5' />
  </svg>
)

const AlertIcon: FC = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'>
    <circle cx='12' cy='12' r='9' />
    <line x1='12' y1='8' x2='12' y2='12' />
    <line x1='12' y1='16' x2='12.01' y2='16' />
  </svg>
)

export default ExportToastBody
